import { Injectable, inject } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { TenantStore } from '@signal-store';

@Injectable({
  providedIn: 'root',
})
export class DemoGuard implements CanActivate {
  private tenantStore = inject(TenantStore);

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.tenantStore.isDemoTenant();
  }
}
